const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/middleware/kisapi/errors.ts';
import messages from './translations';
import _ from 'lodash';
import { MessageDescriptor } from 'react-intl';

export default function createErrorMessage(response: Response) {
    const errorMsg = (messages as any)[Number(response.status).toString()] as MessageDescriptor;
    return !_.isEmpty(errorMsg) ? errorMsg : messages.generalError;
}
